<template>
  <a :href="href" :class="allClasses" title="Ecosia logo" rel="noopener">
    <component
      :is="compact ? 'LogoCompactIcon' : 'LogoColor'"
      class="logo__icon"
      role="img"
      :data-test-id="`logo-icon${compact ? '-compact' : ''}`"
    />
  </a>
</template>

<script>
import classes, { getModifierClass } from '~~/common/vue/mixins/classes';
import LogoColor from '~~/common/vue/components/logos/logo-ecosia-color.svg';
import LogoCompactIcon from '~~/common/vue/components/logos/logo-compact-color.svg';

export default {
  name: 'ELogo',
  components: {
    LogoColor,
    LogoCompactIcon,
  },
  mixins: [classes],
  props: {
    href: {
      type: String,
      required: true,
    },
    compact: {
      type: Boolean,
      default: false,
    },
    // TODO: remove this when paddings are applied per-use-case base
    padding: {
      type: Boolean,
      default: true,
      cssClass: true,
    },
  },
  computed: {
    variant() {
      if (!process || !process.env) {
        return false;
      }
      if (process.env.isBranch) {
        return 'sepia';
      }
      if (process.env.isDev) {
        return 'grayscale';
      }
      return false;
    },
    allClasses() {
      const allClasses = [...this.classes];
      if (this.variant) {
        allClasses.push(getModifierClass('logo', this.variant));
      }
      return allClasses;
    },
  },
};
</script>

<style lang="scss" scoped>
.logo {
  display: block;
}

.logo__icon {
  max-width: 100%;
  height: 100%;
}

.logo--padding {
  .logo__icon {
    padding: $space-1s;
  }
}

.logo--sepia {
  filter: sepia();
}

.logo--grayscale {
  filter: unquote(grayscale(100%));
}
</style>
